module.exports = {
    "format": {
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["", " €"],
        "dateTime": "%A, der %e. %B %Y, %X",
        "date": "%d.%m.%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"], // unused
        "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "shortMonths": ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
    },
    "error": {
        "accepted": "{0} ist kein gültiger {1} für {2}-Darstellungen. Benutzen Sie bitte: {3}.",
        "connections": "Keine Verbindungen verfügbar für {0}.",
        "data": "Keine Daten verfügbar",
        "dataYear": "Für {0} sind keine Daten verfügbar.",
        "lib": "{0}-Darstellungen erfordern das Laden der Bibliothek {1}.",
        "libs": "{0}-Darstellungen erfordern das Laden folgender Bibliotheken: {1}.",
        "method": "{0}-Darstellungen erfordern die Methode {1}.",
        "methods": "Weitere Einstellungen für folgende Methoden {1} sind bei {0}-Darstellungen erforderlich."
    },
    "lowercase": [
        "ein",
        "ein",
        "und",
        "wie",
        "bei",
        "aber",
        "durch",
        "für",
        "von",
        "wenn",
        "in",
        "in",
        "in der Nähe",
        "noch",
        "von",
        "auf",
        "auf",
        "oder",
        "pro",
        "das",
        "die",
        "zu",
        "mit",
        "über",
        "gegen",
        "gegen."
    ],
    "method": {
        "active": "aktive Segmente",
        "color": "Farbe",
        "depth": "Tiefe",
        "dev": "ausführlich",
        "focus": "Fokus",
        "icon": "Symbol",
        "id": "Kennung",
        "height": "Höhe",
        "labels": "Beschriftungen",
        "legend": "Legende",
        "margin": "Rand",
        "messages": "Statusmeldungen",
        "order": "Reihenfolge",
        "search": "Suche",
        "shape": "Form",
        "size": "Größe",
        "style": "Stil",
        "temp": "temporäre Segmente",
        "text": "Text",
        "time": "Zeit",
        "timeline": "Zeitleiste",
        "total": "Segmente gesamt",
        "type": "Typ",
        "width": "Breite",
        "x": "x-Achse",
        "y": "y-Achse",
        "zoom": "Zoom",
        "mode": "Modus",
        "mute": "ausblenden",
        "solo": "isolieren"
    },
    "time": [
        "Datum",
        "Tag",
        "Monat",
        "Zeit",
        "Jahr"
    ],
    "visualization": {
        "bubbles": "Blasen",
        "chart": "Diagramm",
        "geo_map": "Karte",
        "line": "Liniendiagramm",
        "network": "Netzwerk",
        "rings": "Ringe",
        "scatter": "Punktdiagramm",
        "stacked": "Gestapelte Fläche",
        "tree_map": "Baumdiagramm",
        "bar": "Balkendiagramm",
        "box": "Boxplot",
        "paths": "Pfade",
        "pie": "Kreisdiagramm",
        "table": "Tabelle"
    },
    "ui": {
        "and": "und",
        "back": "zurück",
        "collapse": "Zum Ausblenden klicken",
        "error": "Fehler",
        "expand": "Zum Einblenden klicken",
        "loading": "Lade...",
        "more": "{0} weitere",
        "moreInfo": "Für zusätzliche Informationen klicken",
        "noResults": "Keine Ergebnisse für {0} gefunden.",
        "primary": "Primäre Verbindungen",
        "share": "teilen",
        "total": "gesamt",
        "values": "Werte",
        "including": "einschließlich",
        "or": "oder",
        "iqr": "Interquartilsabstände {0}",
        "max": "Maximalwert",
        "min": "Minimalwert",
        "percentile": "Perzentil P{0}",
        "tukey_bottom": "Unterer Ausreißer",
        "tukey_top": "Oberer Ausreißer",
        "quartile_first": "Unteres Quartil Q1",
        "quartile_third": "Oberes Quartil Q3",
        "median": "Medianwert"
    },
    "message": {
        "data": "analysiere Daten",
        "draw": "Darstellung wird gerendert",
        "initializing": "initialisiere {0}",
        "loading": "Daten werden geladen",
        "tooltipReset": "Tooltips zurücksetzen",
        "ui": "aktualisiere Oberfläche"
    },
    "uppercase": [
        "CEO",
        "CEOs",
        "CFO",
        "CFOs",
        "CNC",
        "COO",
        "COOs",
        "CPU",
        "CPUs",
        "BIP",
        "HVAC",
        "ID",
        "IT",
        "FuE",
        "TV",
        "UI"
    ]
}
